import React from 'react';


const Rules = () => {
  return (
    <div className="flex">

    </div>
  );
};

export default Rules;